import React from 'react';
import { Div, P } from '@kizi/core-components';
import { IProduct, useField, usePage } from '@kizi/comparator-core';
import { GoToButton } from '@kizi/comparator-components';

interface RetentionDisclaimerProps {
  field: string;
}

export const RetentionDisclaimer: React.FC<RetentionDisclaimerProps> = ({
  field,
}) => {
  const { state } = usePage();
  const productField = useField(field);
  const productData = JSON.parse(productField?.value as string) as IProduct;
  return state?.retention ? (
    <Div>
      <P variant="bodyRegular" mb={3}>
        {`Het is niet mogelijk uw ${productData.provider.name} abonnement te verlengen. Je kunt
    alleen profiteren van extra korting wanneer je overstapt naar een andere
    aanbieder.`}
      </P>
      <GoToButton variant="primary" index={2}>
        Vergelijk beschikbare pakketten
      </GoToButton>
    </Div>
  ) : null;
};
